import React, { createRef } from "react";
import PropertyMeasurement from "./PropertyMeasurement";
import { Icon } from "@abb/abb-common-ux-react";
import { ABB_LEFT, ABB_RIGHT } from '../../utilities/IconConstants';
import { IInstrumentDetails } from "../../models/measurement/InstrumentDetails";
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { AppContextConsumer } from './MeasurementLanding';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Translation } from "react-i18next";
import ReactDOM from "react-dom";
import * as CONSTANTS from "../../utilities/Constants";
import SampleLoadingIndicator from "../shared/SampleLoadingIndicator";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import Utility from "../shared/Utility";

interface IMeasurementTable {
    details?: boolean;
    measuredSection?: boolean;
    keyedInSection?: boolean;
    calculatedSection?: boolean;
    selectedInstrumentDetail?: IInstrumentDetails;
    selectedKeyedInDetails?: IKeyedInDetails;
    selectedCalculatedDetails?: ICalculatedDetails;
    onMeasuredPositionChange?: (index: number) => void;
    onKeyedInPositionChange?: (index: number) => void;
    isLoadingText: boolean;
    selectedDirection?: any;
    thresholdSettings?: IThresholdSettings[];
}

interface IState {
    activeIndex: number,
    selectedKeyedInDetails?: IKeyedInDetails,
    activeMeasuredIndex?: number
}
export default class MeasurementTable extends React.Component<IMeasurementTable, IState> {
    private _autolineScroll: any;
    private _mount: boolean;
    constructor(props: IMeasurementTable) {
        super(props);
        this._autolineScroll = React.createRef();
        this.onScroll = this.onScroll.bind(this)
    }

    state = {
        activeIndex: this.props.selectedKeyedInDetails?.setPositionVal,
        selectedKeyedInDetails: this.props.selectedKeyedInDetails,
        activeMeasuredIndex: this.props.selectedInstrumentDetail?.setPositionVal
    }
    componentDidUpdate(prevProps: IMeasurementTable) {
        // state upadte for activeIndex
        if (this.state.activeIndex !== this.props.selectedKeyedInDetails?.setPositionVal) {
            this.setState({
                activeIndex: this.props.selectedKeyedInDetails?.setPositionVal
            })
        }

        if (this.props.selectedKeyedInDetails.id !== prevProps.selectedKeyedInDetails.id) {
            this.setState({
                activeIndex: 0
            })
        }
        if (this.props.selectedInstrumentDetail.id !== prevProps.selectedInstrumentDetail.id) {
            this.setState({
                activeMeasuredIndex: 0
            })
        }
    }

    onScroll(e: any) {
        const elm = document.getElementById("scrollBar").scrollLeft;
        document.getElementById("autolinescroll").scrollLeft = elm;
    }

    // MEASURED START
    public createMeasuredColumns = () => {

        const items: any[] = [];
        const countData = this.props.selectedInstrumentDetail?.countData.find(x => x.selected);
        if (this.props.details) {
            if (countData !== undefined) {
                const directions = countData.directions.find(x => x.selected);
                for (let index = 1; index <= directions?.maxCount; index++) {
                    items.push(<th scope="col" key={index}>{index}</th>);
                }
            }
        } else {
            if (this.props.selectedInstrumentDetail.isAutoLine) {
                (this.props.selectedInstrumentDetail.countData || []).map((data, index) => {
                    items.push(<th scope="col" key={index} />);
                })
            } else {
                (this.props.selectedInstrumentDetail.positionCount || []).map((data, index) => {
                    items.push(<th scope="col" key={index} />);
                })
            }

        }

        return items;
    }

    private createMeasuredColumnData = () => {
        const items: any[] = [];
        let countData = this.props.selectedInstrumentDetail.countData.find(x => x.selected);
        if (!countData) {
            countData = this.props.selectedInstrumentDetail.countData[0];
        }
        let selectedDirection: any;
        if (countData !== undefined) {
            selectedDirection = countData.directions.find(x => x.selected);
        }
        let selectedPosition = this.props.selectedInstrumentDetail.positionCount.find(x => x.selected);
        if (!selectedPosition) {
            selectedPosition = this.props.selectedInstrumentDetail.positionCount[0];
        }
        let properties = [];
        const filteredProps = Utility.getUniquePropertiesFromList(this.props.selectedInstrumentDetail.properties);
        if (this.props.details) {
            properties = filteredProps.filter(x => {
                if (selectedDirection !== undefined) {
                    if (selectedDirection.name === "All") {
                        return x
                    } else {
                        return x.directionId === selectedDirection.id
                    }
                } else {
                    if (x.name === "All") {
                        return x
                    } else {
                        return x
                    }
                }
            });
        } else {

            properties = filteredProps;
        }


        if (selectedPosition !== undefined) {
            properties.map((data: any, index) => {
                if (data.directionId === this.props.selectedDirection.id) {
                    const cpProperty = this.props.selectedInstrumentDetail.currentMeasuringProperty;
                    const cpPosition = this.props.selectedInstrumentDetail.currentMeasuringPosition;

                    items.push(<tr className={data.id === cpProperty && selectedPosition.position === cpPosition
                        ? "normal-class active-class" : "normal-class"} key={index}>
                        {this.createData(data.id, data.name, selectedDirection, selectedPosition, data.directionId, cpPosition)}
                    </tr>);
                }
            });
        }
        return items;
    }

    public createData(propertyId: any, propertyName: string, selectedDirection: any, selectedPosition: any, directionId?: string, cpPosition?: number) {
        const items: any[] = [];

        if (this.props.details) {
            if (selectedDirection !== undefined) {
                for (let index = 0; index < selectedDirection?.maxCount; index++) {
                    const readings = this.props.selectedInstrumentDetail.readings;
                    // // properties and directionCounts
                    let dirC: any[] = [];
                    if (selectedDirection.name === "All") {
                        dirC = this.props.selectedInstrumentDetail.directionCounts.filter(x => x.position === selectedPosition.position && x.direction.id == directionId);
                    }
                    let indexNumber = 0;
                    dirC.map((element: any) => {
                        const checkDirection = propertyName.search(element.direction.name)
                        if (checkDirection !== -1) {
                            indexNumber = element.totalCounts
                        }
                    })

                    let mainData;
                    if (readings.length > 0) {
                        if (selectedDirection.name === "All") {
                            if (this.props.selectedInstrumentDetail.isAutoLine) {
                                const countData = this.props.selectedInstrumentDetail.countData.find(x => x.selected === true);
                                const dirCount = this.props.selectedInstrumentDetail.directionCounts.find(x => x.name === countData.positionName);
                                this.props.selectedInstrumentDetail.readings.map((x) => {
                                    if (x.propertyId === propertyId && x.count === index + 1
                                        && x.position === dirCount.position && x.positionName === dirCount.name) {
                                        mainData = x;
                                    }
                                })
                            } else {
                                mainData = readings.find(x => x.count === index + 1 && x.propertyId === propertyId && x.position === selectedPosition.position && x.directionId === directionId);
                            }
                        } else {
                            mainData = readings.find(x => x.count === index + 1 && x.propertyId === propertyId &&
                                x.directionId === selectedDirection.id && x.position === selectedPosition.position);
                        }
                    }
                    const data = mainData !== undefined && mainData.value != null && !isNaN(mainData.value) ? mainData.value.toFixed(mainData.decimals) : indexNumber <= index ? CONSTANTS.NOTCONSIDEREDFORCALC : CONSTANTS.NOTCONSIDEREDFORCALC;
                    let color = "black";
                    if (mainData !== undefined) {
                        if (mainData.valueRange.name === "Alarm Limit1") {
                            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit1")?.colorCode;
                        } else if (mainData.valueRange.name === "Alarm Limit2") {
                            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit2")?.colorCode;
                        } else if (mainData.valueRange.name === "Reject Limit") {
                            color = this.props.thresholdSettings.find(x => x.name === "Reject Limit")?.colorCode;
                        }
                    }

                    let pos = this.props.selectedInstrumentDetail.countData.find(x => x.position === selectedPosition.position);
                    let dir = pos.directions.find(x => x.id === directionId)
                    items.push(<td className={(directionId === this.props.selectedDirection.id) && (dir.completedCounts === index) ? "box-border" : null} scope="col" key={index}><span style={{ color }}>{data}</span></td>);
                }

            }
        } else {
            for (let index = 0; index < this.props.selectedInstrumentDetail.countData.length; index++) {
                const countData = this.props.selectedInstrumentDetail.countData.find(x => x.index === index);
                let dirCount: any;
                if (countData !== undefined) {
                    dirCount = this.props.selectedInstrumentDetail.directionCounts.find(x => x.name === countData.positionName && x.direction.id === directionId);
                }
                let data: any;
                let dirC: any[] = [];
                if (selectedDirection.name === "All") {
                    dirC = this.props.selectedInstrumentDetail.directionCounts.filter(x => x.position === selectedPosition.position && x.direction.id === directionId);
                }
                let indexNumber = 0;
                dirC.map((element: any) => {
                    const checkDirection = propertyName.search(element.direction.name)
                    if (checkDirection !== -1) {
                        indexNumber = element.totalCounts
                    }
                })

                var allValueRangesForAPosition: any[] = [];
                this.props.selectedInstrumentDetail.readings.map((x) => {
                    if (dirCount !== undefined) {
                        if (x.propertyId === propertyId && x.positionName === dirCount.name && x.position === index) {
                            allValueRangesForAPosition.push(x);
                        }
                    }
                });
                var color = this.getRightColorForDashboardView(allValueRangesForAPosition);
                var selectedProperty = this.props.selectedInstrumentDetail?.properties?.find(x => x.id === propertyId);
                const posMean1 = this.props.selectedInstrumentDetail.statistics.find(x => x.propertyId === propertyId && x.position === index && x.directionId === directionId)
                const mean = posMean1 !== undefined ?
                    (!isNaN(posMean1?.mean) ? posMean1?.mean?.toFixed(selectedProperty?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC)
                    : indexNumber <= index ? CONSTANTS.NOTCONSIDEREDFORCALC : CONSTANTS.NOTCONSIDEREDFORCALC;
                items.push(<td scope="col" key={index} >
                    <span style={{ color }} >{mean}</span>
                </td>);
            }
        }
        return items;
    }
    // MEASURED END

    /// Get right color to show in dashboard screen.
    /// Dashboard measurement statistics will not have direct value status, so need to pick right color by looking in all available positions
    /// default color is black
    private getRightColorForDashboardView(allValueRangesForAPosition: any[]): string {
        let color = CONSTANTS.WITHIN_LIMIT_COLOR;
        if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit1)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit1")?.colorCode;
        }
        else if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit2)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit2")?.colorCode;
        }
        else if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.RejectLimit)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Reject Limit")?.colorCode;
        }
        return color;
    }

    // KEYEDIN START
    private createKeyedInHeader() {
        const items: any[] = [];
        if (this.props.details) {
            const selectedPosition = this.props.selectedKeyedInDetails.positionCounts.find(x => x.selected);
            const countData = this.props.selectedKeyedInDetails.countData.find(x => x.selected);
            const selectedDirection = countData.directions.find(x => x.selected);
            if (selectedPosition !== undefined && selectedDirection !== undefined) {
                for (let index = 1; index <= selectedDirection.totalCounts; index++) {
                    items.push(<th scope="col" key={index}>{index}</th>);
                }
            }
        } else {
            (this.props.selectedKeyedInDetails.positionCounts || []).map((data, index) => {
                items.push(<th scope="col" key={index}>{index + 1}</th>);
            })
        }

        return items;
    }

    private createKeyedInColumnData(selectedKeyedInDetails: IKeyedInDetails, countValue: any,
        setOnchange: (e: any, count: number, propertyId: string, item: any) => void,
        onKeyedInCountSubmit: (data: any) => void
    ) {
        const items: any[] = [];
        items.push(<tr className="normal-class" key={Math.random()}>
            {this.createKeyedInData(selectedKeyedInDetails.id, countValue, setOnchange, onKeyedInCountSubmit)}
        </tr>);
        return items;
    }

    public createKeyedInData(propertyId: string, countValue: any,
        setOnchange: (e: any, count: number, propertyId: string, item: any) => void,
        onKeyedInCountSubmit: (data: any) => void
    ) {

        const items: any[] = [];
        const selectedPosition = this.props.selectedKeyedInDetails.positionCounts.find(x => x.selected);
        const countData = this.props.selectedKeyedInDetails.countData.find(x => x.selected);
        const selectedDirection = countData.directions.find(x => x.selected);
    
        if (this.props.details && selectedDirection !== undefined) {
       
            for (let index = 0; index < selectedDirection.totalCounts; index++) {
                const readings = this.props.selectedKeyedInDetails.readings.find(x => x.directionId === selectedDirection.id
                    && x.propertyId === propertyId
                    && x.count === index + 1 && x.position === selectedPosition.position);
                const value = readings !== undefined ? String(readings.value) : "";
                const indexVal = index + 1;
                const completed = this.props.selectedKeyedInDetails.readings
                    .find(x => x.directionId === selectedDirection.id
                        && x.count === index + 1 && x.position === selectedPosition.position);
                const compValue = completed === undefined ? false : completed.completed === undefined ? false : true;
                items.push(<td scope="col" key={index}>
                    <div style={{ margin: "0px auto" }}>
                        <input type="text"
                            key={propertyId + "_" + selectedPosition.position + "_" + index}
                            name={propertyId + "_" + selectedPosition.position + "_" + index}
                            value={value}
                            maxLength={7}
                            className={compValue ? "input-focus count-selected" : "input-focus"}
                            // tslint:disable-next-line: jsx-no-lambda
                            tabIndex={index + 1}
                            autoFocus={countValue === propertyId + "_" + selectedPosition.position + "_" + index ? true : false}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(e) => setOnchange(e, indexVal, propertyId, {})}
                            // tslint:disable-next-line: jsx-no-lambda
                            onKeyDown={(e) => onKeyedInCountSubmit({ e, value, count: indexVal, propertyId, apiCall: true })}
                            // onBlur={(e) => onKeyedInCountSubmit({ e, value, count: indexVal, propertyId, apiCall: true })}
                            disabled={this.props.isLoadingText}
                        />
                    </div>
                </td>)
            }
        } else {
            if (selectedDirection !== undefined) {
                (this.props.selectedKeyedInDetails.countData || []).map((data: any, index: any) => {
                    const readings = this.props.selectedKeyedInDetails.dashboardReading.find(x => x.position === data.position);
                    const meanData = this.props.selectedKeyedInDetails.positionMeans.find(x => x.position === data.position);
              
                    var allValueRangesForAPosition: any[] = [];
                    this.props.selectedKeyedInDetails.dashboardReading.map((x: any) => {
                        if (data !== undefined) {
                            if (x.positionName === data.positionName && x.position === index) {
                                allValueRangesForAPosition.push(x);
                            }
                        }
                    });
                    var color = this.getRightColorForDashboardView(allValueRangesForAPosition);
                    const mean = meanData !== undefined ?
                        (!isNaN(meanData?.mean) ? meanData.mean.toFixed(this.props?.selectedKeyedInDetails?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC) : CONSTANTS.NOTCONSIDEREDFORCALC
                    items.push(<td scope="col" key={index}>
                        <span style={{ color }}>{mean}</span>
                    </td>);
                })
            }
        }
        return items;
    }
    // KEYEDIN END

    // CALCULATED DSTART
    private createCalculatedHeader() {
        const items: any[] = [];
        for (let index = 0; index < this.props.selectedCalculatedDetails.calculatedValues.length; index++) {
            items.push(<th scope="col" key={index}><span>{index + 1}</span></th>);
        }
        return items;
    }

    private createCalculatedColumnData() {
        const items: any[] = [];
        this.props.selectedCalculatedDetails.calculatedValues.map((data: any, index: any) => {
            var allValueRangesForAPosition: any[] = [];
            this.props.selectedCalculatedDetails.calculatedValues.map((x: any) => {
                if (data !== undefined) {
                    if (x.positionName === data.positionName && x.position === index) {
                        allValueRangesForAPosition.push(x);
                    }
                }
            });
            var color = this.getRightColorForDashboardView(allValueRangesForAPosition);
            items.push(
                <td scope="col" key={index}>
                    <span style={{ color }}>{data != null && data.value != null && !isNaN(data.value) ? data.value.toFixed(this.props?.selectedCalculatedDetails?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}</span>

                </td>
            );
        })
        return items;
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            {
                                this.props.isLoadingText && <SampleLoadingIndicator />
                            }
                            {this.props.selectedInstrumentDetail?.isAutoLine ?
                                <div>
                                    <div className="w-100" id="content-data-property" >

                                        <div className={this.props.details ? "overflow-auto transClass" : "rowAutoline autolineScrollBottom"}
                                            id="autolinescroll"
                                            ref={this._autolineScroll}>
                                            {this.props.measuredSection ?
                                                <table className=
                                                    {this.props.details ? "transClass measurement-tbl measurement-tbl-autoline one" :
                                                        "measurement-tbl measurement-tbl-autoline one"}>
                                                    <thead>
                                                        <tr>
                                                            {this.createMeasuredColumns()}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.createMeasuredColumnData()}
                                                    </tbody>
                                                </table> : null}

                                            {this.props.keyedInSection ?
                                                <table className={this.props.details ? "transClass measurement-tbl" : "measurement-tbl measurement-tbl-keyedin"}>
                                                    <thead>
                                                        <tr key={Math.random()}>
                                                            {this.createKeyedInHeader()}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <AppContextConsumer>
                                                            {({ selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit }) =>
                                                                this.createKeyedInColumnData(selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit)}
                                                        </AppContextConsumer>
                                                    </tbody>
                                                </table> : null}


                                            {this.props.calculatedSection ?
                                                <table className="measurement-tbl one">
                                                    <thead>
                                                        <tr>
                                                            {this.createCalculatedHeader()}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="normal-class" key={Math.random()}>
                                                            {this.createCalculatedColumnData()}
                                                        </tr>
                                                    </tbody>
                                                </table> : null
                                            }
                                        </div>
                                    </div>
                                </div> :
                                <div>

                                    <div
                                        className={this.props.details ? "overflow-auto abb-wrapper transClass" : "rowAutoline autolineScrollBottom"}
                                        id="autolinescroll"
                                        ref={this._autolineScroll}
                                    >
                                        {this.props.measuredSection ? <table className=
                                            {this.props.details ? "transClass measurement-tbl one" : " measurement-tbl one"}>
                                            <thead>
                                                <tr>
                                                    {this.createMeasuredColumns()}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.createMeasuredColumnData()}
                                            </tbody>
                                        </table> : null}

                                        {this.props.keyedInSection ?
                                            <table className={this.props.details ? "transClass measurement-tbl" : " measurement-tbl measurement-tbl-keyedin"}>
                                                <thead>
                                                    <tr key={Math.random()}>
                                                        {this.createKeyedInHeader()}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <AppContextConsumer>
                                                        {({ selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit }) =>
                                                            this.createKeyedInColumnData(selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit)}
                                                    </AppContextConsumer>
                                                </tbody>
                                            </table> : null}


                                        {this.props.calculatedSection ?
                                            <table className={this.props.details ? "transClass measurement-tbl one" : "measurement-tbl one"} >
                                                <thead>
                                                    <tr>
                                                        {this.createCalculatedHeader()}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="normal-class" key={Math.random()}>
                                                        {this.createCalculatedColumnData()}
                                                    </tr>
                                                </tbody>
                                            </table> : null
                                        }
                                    </div>
                                </div>}

                        </React.Fragment>
                }
            </Translation>
        )
    }
}